module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-panel"
  }, [_c('div', {
    staticClass: "drug-panel--heads"
  }, [_c('button', {
    staticClass: "btn btn-info icon-right",
    on: {
      "click": function($event) {
        _vm.createDrugGroupForm = true
      }
    }
  }, [_vm._v("新增群組")]), (_vm.createDrugGroupForm) ? _c('CreateDrugGroupForm', {
    on: {
      "closeForm": _vm.closeDrugGroupForm,
      "dataCreated": _vm.dataCreated
    }
  }) : _vm._e()], 1), _c('vuetable', {
    ref: "vuetableGroup",
    attrs: {
      "api-url": (_vm.server + "/api/medication-group/"),
      "data-path": "",
      "fields": _vm.categoryField,
      "http-options": _vm.httpOptions,
      "pagination-path": "",
      "css": _vm.boostrapCss,
      "detail-row-component": "drug-group-detail"
    },
    on: {
      "vuetable:cell-clicked": _vm.onGroupClicked
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteGroup(props.rowData)
            }
          }
        }, [_vm._v("刪除群組")])]
      }
    }])
  }, [_c('medicationGroupCount')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dce683a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/DrugGroupSettings.vue
// module id = 1408
// module chunks = 1